import { useToast } from "@/components/ui/use-toast";
import { StructureAssignmentsService } from "@/modules/structure-assignments/services/structureAssignments";
import { WriteStructureAssignment } from "@/types/structure-assignment";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export const useWriteStructureAssignmentsMutation = (
  onSuccess?: () => void,
) => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: WriteStructureAssignment) =>
      StructureAssignmentsService.put([data]),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["structureAssignments"],
      });
      toast({
        title: t("structureAssignments.success.write"),
      });
      onSuccess?.();
    },
    onError: (error) => {
      toast({
        title: t("structureAssignments.errors.write"),
        description: error.message,
        variant: "destructive",
      });
    },
  });
};
